const EhblHouseBillApiUrls = {
  GET: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/manifest-forward/get`,
  POST: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/manifest-forward/create`,
  PUT: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/manifest-forward/update`,
  DELETE: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/manifest-forward/delete`,
  EXPORT: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/manifest-forward/download`
};

export default EhblHouseBillApiUrls
